// import React, { useState, useEffect } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   TextField,
//   Typography,
//   Box,
//   Paper,
//   Divider,
// } from '@mui/material';

// const StaffAmountDistributionPopup = ({ 
//   open, 
//   onClose, 
//   staffIds, 
//   allStaffData, 
//   totalAmount,
//   onSave,
//   serviceIndex,
//   serviceName,
//   existingStaffDetails 
// }) => {
//   const [staffAmounts, setStaffAmounts] = useState({});

//   // Initialize with existing details or equal distribution
//   useEffect(() => {
//     if (staffIds && staffIds.length > 0 && totalAmount && open) {
//       const hasExistingDetails = existingStaffDetails && existingStaffDetails.length > 0;
      
//       if (hasExistingDetails) {
//         // Use existing distribution
//         const existingAmounts = {};
//         existingStaffDetails.forEach(staff => {
//           existingAmounts[staff.staffId] = staff.workedAmount;
//         });
//         setStaffAmounts(existingAmounts);
//       } else {
//         // First time - use equal distribution
//         const equalAmount = Math.round((totalAmount / staffIds.length) * 100) / 100;
//         const initialAmounts = {};
        
//         staffIds.forEach(staffId => {
//           initialAmounts[staffId] = equalAmount;
//         });
        
//         setStaffAmounts(initialAmounts);
//       }
//     }
//   }, [staffIds, totalAmount, open, existingStaffDetails]);

//   const handleAmountChange = (staffId, value) => {
//     // If input is cleared, set to 0 instead of empty string
//     const numericValue = value === '' ? 0 : parseFloat(value) || 0;
//     setStaffAmounts(prev => ({
//       ...prev,
//       [staffId]: numericValue
//     }));
//   };

//   const handleSave = () => {
//     const staffDetails = Object.entries(staffAmounts).map(([staffId, workedAmount]) => ({
//       staffId,
//       workedAmount: workedAmount || 0,
//       staffName: allStaffData.find(staff => staff._id === staffId)?.name || 'Unknown'
//     }));
    
//     onSave(staffDetails, serviceIndex);
//     onClose();
//   };

//   const getStaffName = (staffId) => {
//     return allStaffData.find(staff => staff._id === staffId)?.name || 'Unknown Staff';
//   };

//   const totalDistributed = Object.values(staffAmounts).reduce((sum, amount) => sum + (amount || 0), 0);
//   const difference = totalAmount - totalDistributed;

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
//       <DialogTitle sx={{ textAlign: 'center', fontWeight: 600, pb: 0 }}>
//         Staff work ratio
//       </DialogTitle>

//       <DialogContent sx={{ pt: 1 }}>
//         {/* Service name and price row */}
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             mb: 2,
//           }}
//         >
//           <Typography
//             variant="body1"
//             sx={{
//               fontWeight: 500,
//               display: 'flex',
//               alignItems: 'center',
//               gap: '6px',
//             }}
//           >
//             <Box
//               sx={{
//                 width: 4,
//                 height: 20,
//                 backgroundColor: '#1976d2',
//                 borderRadius: 1,
//               }}
//             />
//             {serviceName}
//           </Typography>

//           <Typography sx={{ fontWeight: 600 }}>₹{totalAmount}</Typography>
//         </Box>

//         {/* Final Price Field */}
//         <Typography
//           variant="body2"
//           sx={{ mb: 0.5, color: 'text.secondary', fontWeight: 500 }}
//         >
//           Final price
//         </Typography>
//         <TextField
//           value={`₹ ${totalAmount}`}
//           fullWidth
//           size="small"
//           InputProps={{
//             readOnly: true,
//           }}
//           sx={{
//             mb: 2,
//             '& input': {
//               fontWeight: 600,
//               textAlign: 'left',
//             },
//           }}
//         />

//         <Divider sx={{ my: 2 }} />

//         {/* Staff Cards */}
//         {staffIds?.map((staffId) => {
//           const amount = staffAmounts[staffId] || 0;
//           const percentage = totalAmount ? ((amount / totalAmount) * 100).toFixed(2) : 0;

//           return (
//             <Paper
//               key={staffId}
//               sx={{
//                 p: 1.5,
//                 mb: 1.5,
//                 backgroundColor: '#fafafa',
//                 borderRadius: 2,
//                 boxShadow: '0px 1px 3px rgba(0,0,0,0.05)',
//               }}
//               elevation={0}
//             >
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'center',
//                 }}
//               >
//                 <Box>
//                   <Typography fontWeight={600}>{getStaffName(staffId)}</Typography>
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       backgroundColor: '#E3F2FD',
//                       color: '#628ce7ff',
//                       borderRadius: '4px',
//                       px: 0.6,
//                       py: 0.1,
//                       fontWeight: 600,
//                     }}
//                   >
//                     {percentage}%
//                   </Typography>
//                 </Box>

//                 <TextField
//                   type="number"
//                   value={staffAmounts[staffId] || 0}
//                   onChange={(e) => handleAmountChange(staffId, e.target.value)}
//                   size="small"
//                   sx={{
//                     width: '100px',
//                     '& input': {
//                       textAlign: 'right',
//                       fontWeight: 500,
//                     },
//                   }}
//                   InputProps={{
//                     startAdornment: (
//                       <Typography sx={{ mr: 0.5, fontWeight: 500 }}>₹</Typography>
//                     ),
//                   }}
//                 />
//               </Box>
//             </Paper>
//           );
//         })}
//       </DialogContent>

//       <DialogActions sx={{ justifyContent: 'center', p: 2 }}>
//         <Button
//           variant="contained"
//           fullWidth
//           onClick={handleSave}
//           sx={{
//             backgroundColor: '#628ce7ff',
//             borderRadius: 2,
//             textTransform: 'none',
//             fontWeight: 600,
//             py: 1.2,
//             '&:hover': { backgroundColor: '#628ce7ff' },
//           }}
//         >
//           Continue
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default StaffAmountDistributionPopup;

import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  Paper,
  Divider,
} from "@mui/material";

const StaffAmountDistributionPopup = ({
  open,
  onClose,
  staffIds = [],
  allStaffData = [],
  totalAmount = 0,
  onSave,
  serviceIndex,
  serviceName,
  existingStaffDetails = [],
}) => {
  const [staffAmounts, setStaffAmounts] = useState({});
  const [lockedStaff, setLockedStaff] = useState(new Set());
  const [errorMsg, setErrorMsg] = useState("");

  const prevStaffRef = useRef([]);
  const prevAmountRef = useRef(0);

  useEffect(() => {
    if (staffIds?.length && totalAmount != null) {
      const isSameStaff =
        JSON.stringify(prevStaffRef.current) === JSON.stringify(staffIds);
      const isSameAmount = prevAmountRef.current === totalAmount;

      let initial = {};
      if (
        existingStaffDetails &&
        existingStaffDetails.length > 0 &&
        isSameStaff &&
        isSameAmount
      ) {
        existingStaffDetails.forEach((staff) => {
          initial[staff.staffId] =
            staff.workedAmount === "" ? "" : +(staff.workedAmount || 0);
        });
      } else {
        const equal = +(totalAmount / staffIds.length).toFixed(2);
        staffIds.forEach((id) => (initial[id] = equal));
      }

      setStaffAmounts(initial);
      setLockedStaff(new Set());
      prevStaffRef.current = staffIds;
      prevAmountRef.current = totalAmount;
    } else {
      setStaffAmounts({});
      setLockedStaff(new Set());
    }
  }, [staffIds, totalAmount]);

  const handleAmountChange = (changedId, value) => {
    if (value === "") {
      setStaffAmounts((prev) => ({ ...prev, [changedId]: "" }));
      return;
    }

    let newValue = parseFloat(value);
    if (isNaN(newValue) || newValue < 0) newValue = 0;

    const newLocked = new Set(lockedStaff);
    newLocked.add(changedId);

    let updated = { ...staffAmounts, [changedId]: newValue };

    const lockedIds = Array.from(newLocked);
    const lockedTotal = lockedIds.reduce(
      (sum, id) => sum + (parseFloat(updated[id]) || 0),
      0
    );

    const remainingIds = staffIds.filter((id) => !newLocked.has(id));
    let remainingAmount = totalAmount - lockedTotal;

    if (remainingIds.length > 0) {
      if (remainingAmount < 0) {
        updated[changedId] =
          Math.max(0, totalAmount - (lockedTotal - newValue));
        remainingIds.forEach((id) => (updated[id] = 0));
      } else {
        const currentRemainingSum = remainingIds.reduce(
          (sum, id) => sum + (parseFloat(updated[id]) || 0),
          0
        );

        if (currentRemainingSum > 0) {
          remainingIds.forEach((id) => {
            const current = parseFloat(updated[id]) || 0;
            const newShare =
              (current / currentRemainingSum) * remainingAmount;
            updated[id] = +newShare.toFixed(2);
          });
        } else {
          const equalShare = +(remainingAmount / remainingIds.length).toFixed(2);
          remainingIds.forEach((id) => (updated[id] = equalShare));
        }

        const totalNow = Object.values(updated).reduce(
          (a, b) => a + (parseFloat(b) || 0),
          0
        );
        const diff = +(totalAmount - totalNow).toFixed(2);
        if (Math.abs(diff) > 0.01 && remainingIds.length > 0) {
          const lastId = remainingIds[remainingIds.length - 1];
          updated[lastId] = +(updated[lastId] + diff).toFixed(2);
        }
      }
    }

    setStaffAmounts(updated);
    setLockedStaff(newLocked);
  };

  const getDistributionDetails = () =>
    Object.entries(staffAmounts).map(([staffId, workedAmount]) => ({
      staffId,
      workedAmount: workedAmount === "" ? 0 : +(workedAmount || 0),
      staffName:
        allStaffData.find((s) => s._id === staffId)?.name || "Unknown",
    }));

 const handleSave = () => {
  const totalDistributed = Object.values(staffAmounts).reduce(
    (a, b) => a + (parseFloat(b) || 0),
    0
  );

  if (Math.abs(totalDistributed - totalAmount) > 0.009) {
    setErrorMsg("Please ensure the total distributed amount equals the service total.");
    return;
  }

  setErrorMsg("");
  const details = getDistributionDetails();
  onSave(details, serviceIndex);
  onClose(details);
};

  // ✅ Prevent close if invalid total OR user clicks outside / ESC
 const handleDialogClose = (event, reason) => {
  const totalDistributed = Object.values(staffAmounts).reduce(
    (a, b) => a + (parseFloat(b) || 0),
    0
  );

  const isValid = Math.abs(totalDistributed - totalAmount) < 0.009;

  // If user clicks outside or presses escape, prevent closing if invalid
  if (!isValid && (reason === "backdropClick" || reason === "escapeKeyDown")) {
    setErrorMsg("Please distribute the entire amount before closing.");
    return;
  }

  // Reset error and close
  setErrorMsg("");
  onClose(getDistributionDetails());
};


  const getStaffName = (id) =>
    allStaffData.find((s) => s._id === id)?.name || "Unknown Staff";

  const totalDistributed = Object.values(staffAmounts).reduce(
    (a, b) => a + (parseFloat(b) || 0),
    0
  );

  const isValid = Math.abs(totalDistributed - totalAmount) < 0.009;

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle sx={{ textAlign: "center", fontWeight: 600, pb: 0 }}>
        Staff Incentive Ratio
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography sx={{ fontWeight: 500 }}>{serviceName}</Typography>
          <Typography sx={{ fontWeight: 600 }}>₹{totalAmount}</Typography>
        </Box>

        <Divider sx={{ my: 1.5 }} />

        {staffIds.map((staffId) => {
          const raw = staffAmounts[staffId];
          const amountDisplay = raw === "" ? "" : raw;
          const percentage = totalAmount
            ? ((parseFloat(raw) || 0) / totalAmount * 100).toFixed(2)
            : "0.00";
          const isLocked = lockedStaff.has(staffId);

          return (
            <Paper
              key={staffId}
              sx={{
                p: 1.5,
                mb: 1,
                backgroundColor: isLocked ? "#e8f5e9" : "#fafafa",
                borderRadius: 2,
                boxShadow: "0px 1px 3px rgba(0,0,0,0.05)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography fontWeight={600}>{getStaffName(staffId)}</Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      backgroundColor: "#E3F2FD",
                      color: "#628ce7ff",
                      borderRadius: "4px",
                      px: 0.6,
                      py: 0.1,
                      fontWeight: 600,
                    }}
                  >
                    {percentage}%
                  </Typography>
                </Box>

                <TextField
                  type="number"
                  size="small"
                  value={amountDisplay}
                  onChange={(e) => handleAmountChange(staffId, e.target.value)}
                  sx={{
                    width: "100px",
                    "& input": { textAlign: "right", fontWeight: 500 },
                  }}
                  InputProps={{
                    startAdornment: (
                      <Typography sx={{ mr: 0.5, fontWeight: 500 }}>₹</Typography>
                    ),
                  }}
                />
              </Box>
            </Paper>
          );
        })}

        <Divider sx={{ my: 2 }} />

        <Typography
          variant="body2"
          sx={{
            textAlign: "right",
            fontWeight: 600,
            color: isValid ? "green" : "red",
          }}
        >
          Total Distributed: ₹{totalDistributed.toFixed(2)} / ₹
          {totalAmount.toFixed(2)}
        </Typography>

        {!isValid && (
          <Typography
            variant="caption"
            color="error"
            sx={{ textAlign: "center", display: "block", mt: 1 }}
          >
            Total must equal ₹{totalAmount.toFixed(2)} before continuing.
          </Typography>
        )}
      </DialogContent>

      {errorMsg && (
  <Typography
    variant="caption"
    color="error"
    sx={{
      textAlign: "center",
      display: "block",
      mb: 1,
      fontWeight: 500,
    }}
  >
    {errorMsg}
  </Typography>
)}


      <DialogActions sx={{ justifyContent: "center", p: 2 }}>
        <Button
          variant="contained"
          fullWidth
          onClick={handleSave}
          disabled={!isValid}
          sx={{
            backgroundColor: isValid ? "#628ce7ff" : "#ccc",
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            py: 1.2,
          }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StaffAmountDistributionPopup;
